import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { useAuth } from '../auth';
import { wasDemoGuest } from '../lib/demo';

export function RequireAuth({ children }: { children: ReactNode }) {
  const { status } = useAuth();
  const location = useLocation();

  if (status === 'unknown') {
    return (
      <main style={{ padding: '6rem 2rem', textAlign: 'center', color: 'var(--text-2)' }}>
        Loading…
      </main>
    );
  }

  // A Try it guest whose lease ended has no session any more: /try says so
  // and offers a new demo boat, rather than a sign-in it has no account for
  // (TOM-868).
  if (status === 'anonymous' && wasDemoGuest()) {
    return <Navigate to="/try" replace state={{ ended: true }} />;
  }

  if (status === 'anonymous') {
    // activation_return_link: carry the boat `return_to` as a SEPARATE piece of
    // router state rather than leaving it inside `from`. `from` is later
    // validated as a same-origin path (validateFromRedirect ignores query
    // values), so an unvalidated cross-origin return_to riding inside it would
    // reach Activate unchecked. Splitting it out means only the separately
    // guarded copy survives to the success page.
    const params = new URLSearchParams(location.search);
    const returnTo = params.get('return_to');
    params.delete('return_to');
    const qs = params.toString();
    const from = location.pathname + (qs.length > 0 ? `?${qs}` : '');
    return (
      <Navigate to="/login" replace state={{ from, ...(returnTo !== null ? { returnTo } : {}) }} />
    );
  }

  return <>{children}</>;
}
